<virtual-binder [isSession]="false"></virtual-binder>